/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, eqeqeq: 0, no-console: 0, no-unused-vars: 0, no-var: 0 */
/* globals _ */

/*
    Sextant, a Javascript navigation framework
    by Tim Trefren (tim@mixpanel.com)

    Requires:
        jquery
        underscore.js
*/

(function() {
  function Sextant(debug, trace) {
    this.urlpatterns = [];
    this.plugins = [];
    this.history = [];
    this.DEBUG = debug || 0;
    this.TRACE = trace || 0;
    this.current_view = null;
  }

  Sextant.prototype.Debug = function(message, object) {
    switch (this.DEBUG) {
      case 0: // No debug statements
        break;
      case 1: // Firebug
        if (this.TRACE) { console.trace(); }
        console.log(`SEXTANT DEBUG - ` + message);
        if (object) {
          if (object.constructor == String) {
            console.log(object);
          } else {
            console.dir(object);
          }
        }
        break;

      case 2: // Alert
        // Will make this more robust if I need it.
        alert(`SEXTANT DEBUG: ` + message);
        break;
      default:
        alert(`Invalid Sextant.DEBUG setting`);
    }
  };

  Sextant.prototype.UrlPatterns = function(patterns) {
    // Compile regexes
    for (var i in patterns) {
      if (patterns.hasOwnProperty(i) && patterns[i][0].constructor == String) {
        patterns[i][0] = new RegExp(patterns[i][0]);
      }
    }
    this.Debug(`Saved UrlPatterns`, patterns);
    this.urlpatterns = this.urlpatterns.concat(patterns);
  };

  Sextant.prototype.register_plugin = function(plugin) {
    this.plugins.push(plugin);
  };

  Sextant.prototype.execute_plugins = function() {
    var args = Array.prototype.slice.call(arguments);

    // list of functions to call on the plugin,
    // e.g. "init", "run", "post_render", etc.
    var fns = args.shift();
    if (typeof(fns) === `string`) {
      fns = [fns];
    }

    // run appropriate function on each
    _.each(this.plugins, function(plugin) {
      _.each(fns, function(fn) {
        if (plugin[fn]) {
          plugin[fn].apply(plugin, args);
        }
      });
    });
  };

  Sextant.prototype.get_hash = function() {
    /*  Parse the hash.
            Have to use location.href, because location.hash
            automatically unescapes itself.  This screws up our
            URI encoding scheme.
        */
    var href = window.location.href;
    href = href.split(`#`);
    href.shift(); // remove first part
    var hash = href.join(`#`);
    if (hash.length) {
      hash = `#` + hash;
    }
    return hash;
  };

  Sextant.prototype.setURL = function(request) {
    window.location.hash = request.getFullURL();
  };

  Sextant.prototype.updateURL = function(path, params, merge) {
    // Update a URL using a path, and merging in a set of params with the current ones
    merge = (merge === undefined) ? true : merge;

    var request = this.getURLRequest();
    request.path = path;
    if (merge) {
      request.params = $.extend(request.params, params);
    } else {
      request.params = params;
    }

    this.setURL(request);
  };

  Sextant.prototype.getURLRequest = function() {
    // Generate a request object based on the current hash
    var request = new Sextant.Request();
    request = this.UrlParser(request, this.get_hash());
    return request;
  };

  Sextant.prototype.UrlParser = function(request, hash) {
    /*  Parse a hash URL into a request object.
        Ex: #/users/john/doe?name=eric&size=2
        request.path = '#/users/john/doe'
        request.params = { 'name': 'eric', 'size': '2' }

        Possible support for a secondary hashstring in the future,
        e.g. #/home/dev?k=v#a
    */
    var split = hash.split(`?`);
    var path = split.shift();
    split = split.join(`?`);

    var params = {};
    // Parse parameters (e.g k=v&a=b)
    if (split.length) {
      var s_params = split.split(`&`);
      var h = ``, key, val;
      for (var p in s_params) {
        if (s_params.hasOwnProperty(p)) {
          h = decodeURIComponent(s_params[p]);

          // some hashes have == inside them so lets not assume
          // the hash only has 1 equal sign
          split = h.split(`=`);
          key = split.shift();
          val = split.join(`=`);

          // Check if key ends with []; if so it's an array
          if (/\[\]$/.test(key)) {
            key = key.replace(`[]`, ``);
            if (!params[key]) {
              params[key] = [];
            }
            params[key].push(val);
          } else {
            params[key] = val;
          }
        }
      }
    }

    request.setURL(path, params);
    return request;
  };

  Sextant.prototype.update_history = function(request) {
    var HISTORY_LENGTH = 20;
    this.history.splice(0, 0, request);
    if (this.history.length > HISTORY_LENGTH) {
      this.history.pop();
    }
  };

  Sextant.prototype.UrlHandler = function(hash) {
    /*  Match hashstring against registered URLs.
        If found, execute the view's display function.

        Passes captured arguments to the view.
    */
    var request = new Sextant.Request();

    request = this.UrlParser(request, hash);
    this.update_history(request);
    var found = false;
    for (var i in this.urlpatterns) {
      if (this.urlpatterns.hasOwnProperty(i)) {
        var p = this.urlpatterns[i];
        if (p[0].test(request.path)) {

          // pre page render plugin call
          this.execute_plugins([`run`, `pre_render`], request, hash);

          // run the previous view's hide handler
          if (this.current_view) {
            this.current_view.hide(request);
          }

          // run the matched view's display handler
          found = p;
          var matches = p[0].exec(request.path);
          p[1].display(request, _.bind(function() {
            this.execute_plugins(`post_render`, request, hash);
          }, this));


          // update the current_view reference
          this.current_view = p[1];

          break;
        }
      }
    }
    if (found) {
      this.Debug(`URL matched following pattern:`, found);
    } else {
      this.Debug(`Matching URL could not be found for hash: ` + hash);
    }
  };

  Sextant.prototype.run = function(interval) {
    interval = interval || 100;
    var last = ``,
      hash = ``,
      that = this;

    function poll() {
      hash = that.get_hash();
      if (last !== hash) {
        last = hash;
        that.UrlHandler(last);
      }
    }

    function start() {
      that.Debug(`Starting Sextant runner`);
      that.runner = setInterval(function() { poll(); }, interval);
    }

    // initialize plugins
    this.execute_plugins(`init`, this);

    start();
  };

  Sextant.prototype.stop_runner = function() {
    if (!this.runner) { return; }
    clearInterval(this.runner);
    this.runner = null;
  };

  Sextant.Request = function(path, params) {
    this.path = (path) ? path : ``;
    this.params = (params) ? params : {};
  };

  Sextant.Request.prototype.setURL = function(path, params) {
    this.path = (path) ? path : ``;
    this.params = (params) ? params : {};
  };

  Sextant.Request.prototype.getQueryString = function() {
    var p = [];
    for (var key in this.params) {
      if (this.params.hasOwnProperty(key)) {
        if (this.params[key].constructor == Array) {
          for (var i=0; i < this.params[key].length; i++) {
            p[p.length] = key + `[]=` + encodeURIComponent(this.params[key][i]);
          }
        } else {
          p[p.length] = key + `=` + encodeURIComponent(this.params[key]);
        }
      }
    }
    return p.join(`&`);
  };

  Sextant.Request.prototype.getFullURL = function() {
    var url = this.path;
    var inc_params = false;
    for (var prop in this.params) {
      if (this.params.hasOwnProperty(prop)) {
        inc_params = true;
        break;
      }
    }

    if (inc_params) {
      url += `?` + this.getQueryString();
    }
    return url;
  };

  Sextant.View = function(display_callback, hide_callback, container) {
    this.display_callback = display_callback || function() {};
    this.hide_callback = hide_callback || function() {};
    this.container = container || `sextant_container`;
  };

  Sextant.View.prototype.display = function(request, post_render_callback) {
    var args = [request].concat(post_render_callback);

    // Don't want to pass args by reference
    this.display_callback.apply(this, args.slice(0));
  };

  Sextant.View.prototype.hide = function(request) {
    this.hide_callback.call(this, request);
  };

  window.Sextant = Sextant;
})();

}.call(window));